$('.cmn-form-file input[type="file"]').change(function(e) {
	if(e.target.files[0]) {
		var targetContainer = $(this).parent();
		var viewName = targetContainer.find('.btn-file-filename');
		var viewButton = targetContainer.find('.btn-file-select');
		var formName = targetContainer.find('.filename');
		var formData = targetContainer.find('.filedata');
		var clearButton = targetContainer.parent().find('.file-clear');
		var fileReader = new FileReader();

		fileReader.addEventListener("load", function () {
			viewName.text(e.target.files[0].name).addClass('uploaded');
			viewButton.addClass('uploaded');
			clearButton.addClass('uploaded');
			formName.val(e.target.files[0].name);
			formData.val(this.result);
		}, false);
		fileReader.readAsDataURL(e.target.files[0]);
	}
});
$('.file-clear').click(function(e) { //クリアボタンがクリックされたら
	var targetContainer = $(this).parent();
	var viewName = targetContainer.find('.btn-file-filename');
	var viewButton = targetContainer.find('.btn-file-select');
	var formName = targetContainer.find('.filename');
	var formData = targetContainer.find('.filedata');

	$(this).removeClass('uploaded');
	viewName.removeClass('uploaded');
	viewName.text(null);
	$('.cmn-form-file input[type="file"]').val(null);
	viewButton.removeClass('uploaded');
	formName.val(null);
	formData.val(null);
});